module.exports = __webpack_public_path__ + "static/media/wall-blue.8de602bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wall-blue.png
// module id = 140
// module chunks = 0